<template>
  <div class="row">
     <div class="col-md-12 col-lg-12 col-xl-12">
        <div class="card m-b-30">
           <div class="card-header">
               <h5 class="card-title">Mis pedidos</h5>
            </div>
            <div class="card-body">
               <div class="row justify-content-center">              
                  <div class="col-12 col-lg-12">
                     <div class="cart-container border-mid">
                        <div class="cart-head">
                           <div class="table-responsive">
                              <table class="table table-borderless">
                                 <thead>
                                    <tr>
                                       <th scope="col" class="text-center">No. Pedido</th>
                                       <th scope="col" class="text-center">Fecha de compra</th>
                                       <th scope="col" class="text-center">Estatus</th>
                                       <th scope="col" class="text-center">Entrega</th>
                                       <th scope="col" class="text-center">Total</th>
                                       <th scope="col" class="text-center">Ver</th>
                                    </tr>
                                 </thead>
                                 <tbody>
                                    <tr v-for="(pedido, idx) in pedidos" :key="idx">
                                       <th class="text-center" scope="row">{{pedido.order}}</th>
                                       <td class="text-center">{{regularDateFormat(pedido.fecha_pedido)}}</td>
                                       <td class="text-center f-w-7 font-18">{{pedido.estatus}}</td>
                                       <td class="text-center">{{regularDateFormat(pedido.fecha_entrega)}}</td>   
                                       <td class="text-center f-w-7 font-18">{{explicitMoneyFormat(pedido.total)}}</td>
                                       <td class="text-center f-w-7 font-18">
                                          <a class="text-success cursor-pointer" @click.stop="goToOrderDetail(pedido.order_id)"><i class="feather icon-eye"></i></a>
                                       </td>
                                    </tr>
                                 </tbody>
                              </table>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
        </div>
     </div>

  </div>
</template>

<script>

import {mapState} from "vuex";
import formatHelper from "@mixins/formatHelper"
import dateHelper from "@mixins/dateHelper"
import {Pedido} from "../../classes/pedido"
export default {
   name: "OrdersPage",
   mixins: [formatHelper, dateHelper],
   data(){
      return {
         pedidos: []
      }
   },  
   async mounted(){
      await this.getPedidosCliente();
   },   
   computed: {
      ...mapState("auth", ["user", "is_logged"])
   },  
   methods: {
      async getPedidosCliente(){
         this.showLoader("Obteniendo información de pedidos ...")
         const res = await this.xget('/pedidos_cliente/'+this.user.ID);
         if(res.success){
            this.setPedidosCliente(res.data);
         }
         this.stopLoader()
      },      
      setPedidosCliente(pedidosCliente){
         this.pedidos = [];
         pedidosCliente.forEach(pedido => {
            this.pedidos.push(Pedido.fromServicePedidos(pedido));
         });
      },
      async goToOrderDetail(id){
         await this.$router.push({name: "ticket", params: {order_id: id}})
      }
   }

}

</script>